import Phaser from 'phaser'

const createCharacterAnims = (anims: Phaser.Animations.AnimationManager) => {
	const characters = ['alchemist', 'barmaid', 'bartender', 'blacksmith', 'farmer', 'fisherman', 'kid01', 'kid02', 'merchant', 'minter'];
	const dirs = ['up', 'down', 'left', 'right'];
	const types = ['idle', 'walk'];

	characters.forEach(c => {
		types.forEach(t => {
			dirs.forEach(d => {
				anims.create({
					'key': [c, t, d].join('-'),
					frames: anims.generateFrameNames(c, {
								start: 1,
								end: 4,
								prefix: [c, t, d].join('-') + '-',
								suffix: '.png' }),
					repeat: -1,
					frameRate: 7
				});
			});
		});
	});

	anims.create({
		key: 'minting',
		frames: anims.generateFrameNames('minting', { start: 0, end: 5, prefix: 'minting ', suffix: '.aseprite' }),
		frameRate: 10,
		repeat: -1
	})

	anims.create({
		key: 'minted',
		frames: anims.generateFrameNames('minting', { start: 6, end: 15, prefix: 'minting ', suffix: '.aseprite' }),
		frameRate: 7,
		repeat: 0
	})

	anims.create({
		key: 'explosion',
		frames: anims.generateFrameNames('explosion', { start: 0, end: 4, prefix: 'explosion ', suffix: '.aseprite' }),
		frameRate: 7,
		repeat: 0
	})

}

export {
	createCharacterAnims
}
